module.exports = __webpack_public_path__ + "media/images/landing/persons/david-kratky-78dafa91aff3e3347b648c7c9861ec05.png";